import { render } from "./JarsBlackTheParnasGold_2026.vue?vue&type=template&id=7c6428ca"
const script = {}

import exportComponent from "/Users/taesungkim/Git/parnas-app-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__